import { ToggleSwitch } from '../../controls/toggle-switch'
import { Field } from '../field'
import type { ToggleFieldProps } from './types'

const ToggleField = ({ label, disabled, error, align, onChange, ...rest }: ToggleFieldProps) => {
  return (
    <Field error={error}>
      <ToggleSwitch
        {...rest}
        disabled={disabled}
        error={!!error}
        label={label}
        align={align}
        onChange={onChange}
      />
    </Field>
  )
}
export default ToggleField
